import { useTranslation } from 'react-i18next'
import { Separator } from '@/components/ui/separator'
import { SupplierInstallationsSectionCard } from '@/features/suppliers/components/supplier-installations-section-card'
import { useSupplierOrganizationForm } from '@/features/suppliers/context/supplier-organization-form-context'

export function SupplierOrganizationInstallationsPage() {
  const { t } = useTranslation('installations')
  const { supplierOrganizationId, canEdit } = useSupplierOrganizationForm()

  return (
    <div className="flex flex-1 flex-col">
      <div className="flex-none">
        <h3 className="text-lg font-medium">
          {t('suppliers.edit.pages.installations.title')}
        </h3>
        <p className="text-sm text-muted-foreground">
          {t('suppliers.edit.pages.installations.description')}
        </p>
      </div>
      <Separator className="my-4 flex-none" />
      <div className="faded-bottom h-full w-full overflow-y-auto scroll-smooth pe-4 pb-12">
        <SupplierInstallationsSectionCard
          supplierOrganizationId={supplierOrganizationId}
          canEdit={canEdit}
          variant="plain"
        />
      </div>
    </div>
  )
}
